// Rows cut off at the leaderboard's edges are the cue that it scrolls, so its
// height is measured from the rows (they grow when a long username wraps) to
// end mid-row. Scrolls the list itself so only it moves, not <main>, and
// waits for load as the CSS from main.js changes row heights.

import { scrollBehavior } from './preferences.js'

const FULL_ROWS = 5
// How far into the top row the window starts when showing the player's row.
// With a window of FULL_ROWS + 0.5 rows, 0.25 leaves 3/4 of a row showing
// at both edges.
const TOP_ROW_OFFSET = 0.25

const ownRow = (list) => list.querySelector('[aria-current="true"]')

const rowTop = (list, row) => row.offsetTop - list.firstElementChild.offsetTop

const sizeList = (list) => {
    const rows = list.children
    if (rows.length <= FULL_ROWS) {
        list.style.maxHeight = 'none'
        return
    }
    const halfRow = rows[FULL_ROWS]
    list.style.maxHeight = `${rowTop(list, halfRow) + halfRow.offsetHeight / 2}px`
}

const showOwnRow = (list, behavior) => {
    const row = ownRow(list)
    if (!row) return

    let top = 0
    // Unless it's already fully visible from the top, e.g. the top few ranks,
    // start two rows above it to leave the player's row near the middle.
    // Past the end clamps to the bottom, which also ends mid-row.
    if (rowTop(list, row) + row.offsetHeight > list.clientHeight) {
        const rows = Array.from(list.children)
        const topRow = rows[Math.max(rows.indexOf(row) - 2, 0)]
        top = rowTop(list, topRow) + topRow.offsetHeight * TOP_ROW_OFFSET
    }
    list.scrollTo({ top, behavior })
}

// aria-disabled rather than disabled, so the button keeps focus once its
// own scroll brings the row into view
const initFindButton = (button) => {
    const list = document.getElementById(button.getAttribute('aria-controls'))
    const row = list && ownRow(list)
    // Nothing to find in a list that doesn't scroll
    if (!row || list.scrollHeight <= list.clientHeight) return

    new IntersectionObserver(
        ([entry]) =>
            button.setAttribute(
                'aria-disabled',
                entry.intersectionRatio >= 0.99
            ),
        { root: list, threshold: 0.99 }
    ).observe(row)

    button.addEventListener('click', () => {
        if (button.getAttribute('aria-disabled') === 'true') return
        showOwnRow(list, scrollBehavior())
    })
    button.hidden = false
}

const init = () => {
    document.querySelectorAll('[data-leaderboard]').forEach((list) => {
        sizeList(list)
        showOwnRow(list)
        // The height depends only on the rows up to the half row
        const resizer = new ResizeObserver(() => sizeList(list))
        Array.from(list.children)
            .slice(0, FULL_ROWS + 1)
            .forEach((row) => resizer.observe(row))
    })
    document.querySelectorAll('[data-leaderboard-find]').forEach(initFindButton)
}

if (document.readyState === 'complete') {
    init()
} else {
    window.addEventListener('load', init, { once: true })
}
